import type { FunctionComponent } from "react";
import { Text } from "@smartsuite/react-ui/lib";
import { intervalToDuration, formatDuration } from "date-fns";

import { TextFieldWrapper } from "../TextFieldWrapper/TextFieldWrapper";

interface DurationFieldProps {
  value: number;
}

export const DurationField: FunctionComponent<DurationFieldProps> = ({
  value,
}) => {
  const duration = intervalToDuration({ start: 0, end: value * 1000 });

  // TODO: Add correct Locale for this and localize
  const formattedDuration = formatDuration(duration, {
    format: ["hours", "minutes", "seconds"],
  });

  return (
    <TextFieldWrapper>
      <Text wrapMode="ellipsis">{formattedDuration}</Text>
    </TextFieldWrapper>
  );
};
